<template>
  <va-create-layout :title="title">
    <va-form v-model="form" :item="item">
      <v-row justify="center">
        <v-col sm="12">
          <v-card>
            <v-card-text>
              <va-text-input required source="name"></va-text-input>
              <va-text-input required source="email"></va-text-input>
              <va-password-input required source="password"></va-password-input>
              <v-autocomplete
                v-model="form.timezone"
                source="timezone"
                label="Timezone"
                filled
                :items="timezonesData"></v-autocomplete>
              <va-select-input
                filled
                required
                source="organizations"
                reference="organizations"
                item-value="@id"
                multiple>
              </va-select-input>
              <va-select-input filled required source="domains" reference="domains" item-value="@id" multiple>
              </va-select-input>

              <va-save-button></va-save-button>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </va-form>
  </va-create-layout>
</template>

<script>
  import { formattedTimezonesData } from "@/utility/getAllTimezones";

  export default {
    props: {
      id: {
        type: String,
        required: false,
        default: "",
      },
      title: {
        type: String,
        required: true,
      },
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        timezonesData: formattedTimezonesData,
        form: {
          timezone: "",
        },
      };
    },
  };
</script>
